import React from 'react'
import WorkOrderSummaryList from '../../components/workordercomponents/WorkOrderSummaryList'

function Workorderdetails(renderPageContent) {
    return (
        <>
                        <WorkOrderSummaryList renderPageContent={renderPageContent}/>
                     

        </>
    )
}

export default Workorderdetails
